import React from "react";
import {
  Accounts,
} from "./../components/company";
import { Layouts, Loaders } from "../components";
import { CompanyContext } from "./../contexts/CompanyContext";

function AccountsListPage() {
  const { selectedCompany } = React.useContext(CompanyContext);

  if (!selectedCompany) {
    return <Loaders.SpacedPageLoader />
  }

  return (
    <>
      <Layouts.PageHeader left="Company Accounts" />
      <div className="px-3">
        <Accounts.List companyId={selectedCompany.slug} />
        <Accounts.Invites companyId={selectedCompany.slug} />
      </div>
    </>
  );
}

AccountsListPage.defaultProps = {};

AccountsListPage.propTypes = {};

export default AccountsListPage;